import React, { createContext, useContext, useMemo } from "react";
import type { PropsWithChildren } from "react";

export interface EntityProviderState<T> {
  entity: T | undefined;
  refresh?: () => void | Promise<void>;
}

// eslint-disable-next-line  @typescript-eslint/no-explicit-any
const EntityProviderContext = createContext<EntityProviderState<any>>({ entity: undefined, refresh: undefined });

export const useEntity = <T,>(): EntityProviderState<T> => {
  return useContext(EntityProviderContext);
};

type EntityProviderProps<T> = PropsWithChildren<{
  entity: T;
  refresh?: () => void | Promise<void>;
}>;

export function EntityProvider<T>(props: EntityProviderProps<T>) {
  const { entity, refresh, children } = props;

  const stateValue = useMemo(() => entity, [entity]);

  return (
    <EntityProviderContext.Provider value={{ entity: stateValue, refresh }}>{children}</EntityProviderContext.Provider>
  );
}
